import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetCustomerBalanceSummaryQuery } from "../../../services/Reports";
import {
  getCustomerBalanceSummaryRequest,
  getCustomerBalanceSummaryFailure,
  getCustomerBalanceSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allCustomerBalanceSummary,
    isLoading: customerBalanceSummaryLoading,
    isError: customerBalanceSummaryError,
  } = useGetCustomerBalanceSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.customerBalanceSummaryPageNo,
    pageSize: state.customerBalanceSummaryPageSize,
    fromDate: new Date(
      state.customerBalanceSummaryFromDate,
    ).toLocaleDateString(),
    toDate: new Date(state.customerBalanceSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (customerBalanceSummaryLoading) {
      dispatch(getCustomerBalanceSummaryRequest());
    }
    if (customerBalanceSummaryError) {
      dispatch(getCustomerBalanceSummaryFailure(customerBalanceSummaryError));
    }
    if (allCustomerBalanceSummary) {
      dispatch(
        getCustomerBalanceSummarySuccess({
          data:
            allCustomerBalanceSummary.data.customerBalancesSummary[0].data ||
            [],
          totalPages:
            allCustomerBalanceSummary.data.customerBalancesSummary[0]
              .metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allCustomerBalanceSummary,
    profileData,
    state.customerBalanceSummaryFromDate,
    state.customerBalanceSummaryToDate,
    state.customerBalanceSummaryPageNo,
    state.customerBalanceSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
